import { ButtonCus } from '@/components/common/Button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/common/Form';
import FormatNumberVer2 from '@/components/react-number-format/ReactNumberFormartver2';
import { useStore } from '@/hooks/useStore';
import yup from '@/services/yup';
import { ADDITIONAL_CHARGE_TYPE, GROUP_CAPACITY_TYPE, OTHER_SETTING_TYPE } from '@/types/enums';
import { OtherSettingItem } from '@/types/system-setting';
import { yupResolver } from '@hookform/resolvers/yup';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default observer(function DropOffSetting() {
    // hook
    const { t } = useTranslation();

    // store
    const { systemSettingStore: { droppOffCMS, getMileageLimitAndDropOffSetting, updateMileageLimitAndDropOffSetting }, modalStore: { showAlertModal } } = useStore();

    // validate Schema

    const validateSchema = yup.object({
        price: yup
            .string()
            .trim()
            .checkInputOnlyPositiveDigitsOrEmpty(t('form_error_validate.only_number'))
            .required('form_error_validate.required')
    });

    type FormData = yup.InferType<typeof validateSchema>;

    // state
    const form = useForm<FormData>({
        resolver: yupResolver(validateSchema),
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        defaultValues: {
            price: '0'
        }
    });

    // life cycle
    useEffect(() => {
        if (droppOffCMS && Object.keys(droppOffCMS).length > 0) {
            let dropOff = droppOffCMS?.length > 0 ? droppOffCMS[0] : {} as OtherSettingItem;

            form.reset({
                price: dropOff?.price?.toString() ?? '0'
            });
        }
    }, [droppOffCMS]);

    // function
    const onSubmit = async (data: FormData) => {
        const payload = {
            format: OTHER_SETTING_TYPE.DROP_OFF,
            data: {
                ...data,
                additionalChargesType: ADDITIONAL_CHARGE_TYPE.NONE,
                format: OTHER_SETTING_TYPE.DROP_OFF,
                capacityType: GROUP_CAPACITY_TYPE.NONE

            }
        };
        const res = await flowResult(updateMileageLimitAndDropOffSetting(payload));
        if (res) {
            getMileageLimitAndDropOffSetting();
            showAlertModal({
                id: 'success',
                type: 'success',
                content: t('messages.update_success')
            });
        }
    };

    return (
        <div className='layout-card'>
            <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className='flex flex-col gap-6'>
                    <h3><FormLabel required>{t('field.content')}</FormLabel></h3>
                    <div className='w-full max-w-[410px]'>
                        <div className='h-[60px] flex font-medium items-center justify-center py-[15px] border border-border-gray2 bg-subtle'>レンタルごとの料金</div>
                        <div className='min-h-[60px] py-[10px] border-b border-x border-border-gray2'>
                            <FormField
                                control={form.control}
                                name='price'
                                render={({ field }) => {
                                    return (
                                        <FormItem className='flex flex-col justify-center items-center'>
                                            <div>
                                                <FormControl>
                                                    <div className='w-fit flex items-center'>
                                                        <FormatNumberVer2
                                                            decimalScale={0}
                                                            statusDisplay='input'
                                                            thousandSeparator={true}
                                                            allowNegative={false}
                                                            className='h-8 w-[100px] border rounded py-1 px-2 font-normal disabled:cursor-default'
                                                            value={field.value}
                                                            setvalueOfNumericFormat={(values) => {
                                                                field.onChange(values);
                                                            }}
                                                        />
                                                        <div>
                                                            円/1km
                                                        </div>
                                                    </div>
                                                </FormControl>
                                                <FormMessage />
                                            </div>

                                        </FormItem>
                                    );
                                }}
                            />
                        </div>
                    </div>
                    <div className='flex justify-center mb-2'>
                        <ButtonCus variant='default' type='submit' size='md'>{t('button.save')}</ButtonCus>
                    </div>
                </form>
            </Form>
        </div>
    );
});
